import { apiErrorMessage } from '../ApiError';
import { axiosApi } from '../axios.api';
import { SalaryDataArray, SalaryModel, SalaryQueryParams } from '@app/interfaces/salary';

const url = `/api/employee/salaries`;

export const getSalariesApi = async (params?: SalaryQueryParams): Promise<SalaryDataArray | undefined> => {
  try {
    const response = await axiosApi.get<SalaryDataArray>(url, { params });
    return response.data;

  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const createSalaryApi = async (data: SalaryModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const updateSalaryApi = async (employeeId: number, formData: SalaryModel) => {
  try {
    const response = await axiosApi.put(`${url}/${employeeId}`, formData);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const deleteSalaryeApi = async (employeeId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${employeeId}`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const exportSalaryApi = async (params?: Record<string, any>, filename = 'bang_luong.xlsx'): Promise<void> => {
  try {
    const response = await axiosApi.get(`${url}/export`, { params, responseType: 'blob' });
    const objectUrl = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = objectUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(objectUrl);
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

const downloadBlob = (data: BlobPart, filename: string) => {
  const objectUrl = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
};

export interface InsuranceRegisterRow {
  employee_id: number;
  employee_code: string;
  name: string;
  social_insurance_number: string | null;
  contract_salary: number;
  insurance_base: number;
  unemployment_base: number;
  company_social: number;
  company_health: number;
  company_unemployment: number;
  company_total: number;
  employee_social: number;
  employee_health: number;
  employee_unemployment: number;
  employee_total: number;
  grand_total: number;
  note: string | null;
}

type InsuranceRate = Record<'social' | 'health' | 'unemployment', number>;

export interface InsuranceRegister {
  period: string;
  approved: boolean;
  rates: { employee: InsuranceRate; company: InsuranceRate };
  rows: InsuranceRegisterRow[];
  totals: Partial<InsuranceRegisterRow>;
  headcount: number;
  missing_number_count: number;
  decreases: Array<{ employee_id: number; name: string; insurance_base: number }>;
}

export const getInsuranceRegisterApi = async (period: string, filters?: Record<string, unknown>): Promise<InsuranceRegister> => {
  try {
    const response = await axiosApi.get(`${url}/insurance_register`, { params: { ...filters, period } });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
    throw error;
  }
};

export const exportInsuranceRegisterApi = async (period: string, filters?: Record<string, unknown>): Promise<void> => {
  try {
    const response = await axiosApi.get(`${url}/export_insurance_register`, { params: { ...filters, period }, responseType: 'blob' });
    downloadBlob(response.data, `bang_bhxh_${period}.xlsx`);
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const recalculatePayrollPeriodApi = async (period: string): Promise<{ message: string } | undefined> => {
  try {
    const response = await axiosApi.post(`${url}/recalculate_period`, { period });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const makePeriodApi = async (data: SalaryModel) => {
  try {
    const response = await axiosApi.post(`${url}/make_period`, data);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
}

export interface SyncInsuranceResult {
  message: string;
  updated: number;
  unchanged: number;
  skipped_locked: number;
  failed: number;
}

/** Cập nhật "Mức lương đóng BHXH" trên phiếu lương của kỳ theo hồ sơ nhân viên. */
export const syncInsuranceApi = async (period: string): Promise<SyncInsuranceResult | undefined> => {
  try {
    const response = await axiosApi.post(`${url}/sync_insurance`, { period });
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
};

export const periodListApi = async () => {
  try {
    const response = await axiosApi.get(`${url}/period_list`);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
}

export const approvePeriodApi = async (data: string) => {
  try {
    const response = await axiosApi.post(`${url}/approve`, data);
    return response.data;
  } catch (error: any) {
    apiErrorMessage(error);
  }
}

// export const getActivitiesApi = async (params: string) => {
//   try {
//     const response = await axiosApi.get(`${url}/activities`, { params });
//     return response.data;
//   } catch (error: any) {
//     apiErrorMessage(error);
//   }
// };
